import { Tooltip } from 'bootstrap'

export default {
    mounted(el) {
        //console.log("tooltip");
        if(!el.tooltip){
            el.tooltip = new Tooltip(el);
        }
    }
}